module.exports = __webpack_public_path__ + "assets/ic_tree14.0c36c315.svg";